import React, { useCallback } from 'react'
import { Form, Select } from 'antd'
import { useModalContext } from '@context/modalContext'
import { useMessage } from '@hooks/useMessage'
import axiosInstance from '../../../config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import styles from './ProfileUpdate.module.scss'
import ButtonUi from '../../ui/ButtonUi/ButtonUi'
import InputWithLabel from '../../ui/InputWithLabel/InputWithLable'
import { EUserRoles } from '@enums/roles'
import { roleNameMapper } from '@utils/mappers'
import WithLabel from '@components/ui/WithLabel/WithLabel'
import CrmSelect from '@components/ui/CrmSelect/CrmSelect'
import { IUsers } from '@interfaces/user.interface'
import { useUserSelector } from '@store/selectors/auth'
import { IconCheckCircle, IconTimesCircle } from '@utils/icons'

const { Option } = Select

interface ICreate {
  login: string
  nickName: string
  password: string
}

interface Props {
  update?: () => void
}

const ProfileUpdateModal: React.FC<Props> = ({ update }) => {
  const user = useUserSelector()
  const { setModalComponent } = useModalContext()
  const { error, success } = useMessage()
  const updateHandler = useCallback(async (e: ICreate) => {
    try {
      await axiosInstance.put(serverPath.USERS + '/' + user.id, { ...e, role: user.role })
      success('Профиль обновлен успешно')
      update && update()
      setModalComponent({ component: null })
    } catch (e) {
      error(errorMapper(ErrorMessages.UPDATE_DATA, e), 'Ошибка обновлении профиля')
    }
  }, [])
  return (
    <div className={styles.container}>
      <div className={styles.header}>Редактировать Профиль</div>
      <Form name='basic' onFinish={updateHandler}>
        <Form.Item
          className={styles.item}
          initialValue={user.login}
          rules={[
            { required: true, message: 'Введите логин' },
            { min: 3, message: 'Минимальная длинна 3 символа' },
          ]}
          name='login'
        >
          <InputWithLabel placeholder='Логин' label='Логин:' disabled />
        </Form.Item>
        <Form.Item
          className={styles.item}
          initialValue={user.nickName}
          rules={[
            { required: true, message: 'Введите ник' },
            { min: 3, message: 'Минимальная длинна 3 символа' },
          ]}
          name='nickName'
        >
          <InputWithLabel placeholder='Ник' label='Ник:' />
        </Form.Item>
        <Form.Item
          className={styles.item}
          rules={[
            { max: 10, message: 'Длинна не больше 10 символов' },
            { min: 3, message: 'Минимальная длинна 3 символа' },
          ]}
          name='password'
        >
          <InputWithLabel placeholder='Пароль' label='Пароль:' />
        </Form.Item>
        <div className={styles.actions}>
          <ButtonUi color='red' onClick={() => setModalComponent({ component: null })}>
            <IconTimesCircle width='18' height='18' fill='var(--color-red)' />
            Отмена
          </ButtonUi>
          <ButtonUi type='primary' htmlType='submit' color='green'>
            <IconCheckCircle width='18' height='18' fill='var(--color-green)' />
            Обновить
          </ButtonUi>
        </div>
      </Form>
    </div>
  )
}

export default ProfileUpdateModal
